import debounce from 'lodash-es/debounce';
import get from 'lodash-es/get';
import React, { useState } from 'react';

import useAudiences from '../../../hooks/useAudiences';
import AutocompleteTextField from '../../forms/AutocompleteTextField';

interface TargetingAudiencesFieldProps {
  name: string;
  valueLabel?: string;
}

function TargetingAudiencesField({ name, valueLabel = '' }: TargetingAudiencesFieldProps) {
  const [keyword, setKeyword] = useState('');

  const {
    data: audienceSegmentsList,
    isLoading,
  } = useAudiences(keyword);

  const throttledSetKeyword = debounce(setKeyword, 500);

  const onInputChange = (event, value, reason) => {
    // Initiate a search on all reasons except when reason is 'reset'.
    // react-hook-forms will trigger that event when user chooses a value in the dropdown
    // and cause an extraneous search on the server with that chosen value.
    if (reason !== 'reset') {
      throttledSetKeyword(value);
    }
  }

  const AUDIENCE_SEGMENTS = get(audienceSegmentsList, 'collection', []).map(item => ({ value: item.segment_id, label: item.name}));

  return(
    <AutocompleteTextField
      name={name}
      label="Name"
      placeholder="Name"
      options={AUDIENCE_SEGMENTS}
      sx={{ width: '100%'}}
      valueLabel={valueLabel}
      onInputChange={onInputChange}
      loading={isLoading}
    />
  )
}

export default TargetingAudiencesField;
